"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
const FormSelectOption = _ref => {
  let {
    id,
    className,
    selectedText,
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
};
FormSelectOption.propTypes = {
  id: _propTypes.default.string,
  className: _propTypes.default.string,
  value: _propTypes.default.any,
  selectedText: _propTypes.default.string,
  children: _propTypes.default.node
};
FormSelectOption.defaultProps = {
  id: undefined,
  className: undefined,
  value: undefined,
  selectedText: undefined,
  children: undefined
};
FormSelectOption.displayName = 'FormSelectOption';
var _default = exports.default = FormSelectOption;